<script lang="ts" setup>
import { ref, onMounted, reactive, nextTick } from "vue";
import { getMonthNames, getWeekdayNamesShort } from "@/editor/CalenderHelper";
import { Globals } from "@/Globals";
import AUApi from "@/api";
import { globalsBezeichnung } from "@/local";
import baseList from "@/components/baseList.vue";
import Constants from "@/Constants";
import {
  getKZValueDisplay,
  getKennungValue,
  getKZTitle,
  getKZValue,
} from "@/DataHelper";
import { showDialog, showSnackbar } from "@/UIHelper";
// import MdRelativeDestChart from "@/components/MD/relativeDestChart.vue";
import { isPhone } from "@/DeviceInfoPlugin";
import { getSiteData } from "@/NavigationHelper";

import { mountedBase, BaseSetup, reloadData } from "@/DataLoaderStatic";
declare interface ChartListItems {
  destination: number;
  value: number;
}
const props = defineProps<{
  stdAnzeige?: string;
  std?: number;
  vonAnzeige?: string;
  bisAnzeige?: string;
  day?: Date | null;
  contentHeight?: number;
  showError?: boolean;
}>();
const emit = defineEmits<{
  back: [];
  dataloaded: { data: any };
}>();
let lokaleStd: number = 0;
let stdAnzeigeBerechnet: number = 0;
let showDialogLocal = ref<boolean>(false);
let verbuchtAnzeige = ref<number>(0);
let verbucht = ref<string>("");
let diff = ref<string>("");
let stdAnzeigeString = ref<string>("");
let diffAnzeige: number = 0.0;

let tag = ref<number>(0);
let wochenTag = ref<string>("");
let monat = ref<string>("-");
let innerHeight: number = 199;
let sperre: boolean = false; // dürfen Tage nicht mehr bearbeitet werden- dann wird sperre gesetzt

let von = ref<string>("");
let bis = ref<string>("");
let showChart = ref<boolean>(false);
let items = ref<ListItems[]>([]);
let heightLocal = ref<number>(props.contentHeight ?? innerHeight);
let editZeitbereich = ref<APIZeitbereich | null>(null);
let warningBtnVisible = ref<boolean>(false);
let holiday = ref<any>(null);
let initalized = ref<boolean>(false);
let chartItems = ref<ChartListItems[]>([]);
let backFunction: (() => void) | null = null;
let valueNegativ = ref<boolean>(false);
let setCompKey = ref<number>(0);
let setCompKeyList = ref<number>(0);
let allesVerbucht = ref<boolean>(false);
const siteData = getSiteData();
let titleColor = ref<string>("dvhBackground");
const pageParams: DataPageParameter = {
  zeitbereich: AUApi.Current.zeitbereich,
  insertMode: false,
  query: "Web_Aufteilung_Projektstunden",
  emitBack: () => emit("back"),
};
const uiData = reactive<DataPageUIData>(BaseSetup(pageParams));

onMounted(async () => {
  if (siteData?.query) {
    pageParams.query = siteData.query;
  }
  // von der VG Sicht wird der AIC mit übergeben
  if (siteData && siteData.aic) {
    pageParams.aic = siteData.aic;
  }
  if (siteData?.zulagen) {
    heightLocal.value = 600;
  }

  initalized.value = false;
  showChart.value = false;
  if (Constants.isMobile) {
    showChart.value = false;
  } else {
    await mountedBase(uiData, pageParams, false);
  }

  lokaleStd = props.std ?? 0;
  const days = getWeekdayNamesShort();
  let dayLocal = props.day ?? siteData?.day;
  if (!dayLocal) {
    dayLocal = AUApi.Current.zeitbereich.von;
  }
  von.value = props.vonAnzeige ?? "";
  bis.value = props.bisAnzeige ?? "";
  const d = dayLocal;
  wochenTag.value = days[d.getDay()];
  tag.value = dayLocal.getDate();
  monat.value = getMonthNames()[dayLocal.getMonth()];
  const holidayLocal = AUApi.Current.getHoliday(d);

  if (holidayLocal) {
    holiday.value = holidayLocal;
    titleColor.value = "red";
  }
  editZeitbereich.value = {
    von: dayLocal,
    bis: dayLocal,
    bereich: "Tag",
  };
  if (!editZeitbereich) {
    return;
  }
  // auf tag eingrenzen
  editZeitbereich.value = {
    von: editZeitbereich.value.von,
    bis: editZeitbereich.value.von,
    bereich: "Tag",
  };

  await refreshItems();
  uiData.showLoading = false;
  uiData.initialized = true;
});

async function refreshItems() {
  // FehlerListe neu laden
  items.value = []; // ausleeren für refresh
  verbuchtAnzeige.value = 0;
  for (let i = 0; i < uiData.data.length; i++) {
    const row = uiData.data[i];
    const header = getKZValueDisplay(row, "header", uiData.columns);
    const differenz: any = getKennungValue(row, "hours", uiData.columns);

    verbuchtAnzeige.value += differenz;
    let title = getKZValueDisplay(row, "titel", uiData.columns);

    if (title && !siteData.zulagen) {
      const textTitle = getKZTitle(row, "titel", uiData.columns);
      title = textTitle + ": " + title;
    }
    let title2 = getKZValueDisplay(row, "titel2", uiData.columns);

    if (title2) {
      const textTitle2 = getKZTitle(row, "titel2", uiData.columns);
      title2 = textTitle2 + ": " + title2;
    }

    let subtitel = getKZValueDisplay(row, "subtitel", uiData.columns);
    if (subtitel) {
      const textSubtitel = getKZTitle(row, "subtitel", uiData.columns);
      subtitel = textSubtitel + ": " + subtitel;
    }
    let subtitel1 = getKZValueDisplay(row, "subtitel1", uiData.columns);
    if (subtitel1) {
      const textSubtitel1 = getKZTitle(row, "subtitel1", uiData.columns);
      subtitel1 = textSubtitel1 + ": " + subtitel;
    }
    const warnung = getKZValueDisplay(row, "warnung", uiData.columns);
    let text = getKZValueDisplay(row, "text", uiData.columns);
    if (text) {
      const textTitel = getKZTitle(row, "text", uiData.columns);
      text = textTitel + ": " + text;
    }
    const icon = getKZValueDisplay(row, "icon", uiData.columns);
    sperre = getKZValueDisplay(row, "sperre", uiData.columns);

    stdAnzeigeBerechnet = getKZValueDisplay(row, "Ist", uiData.columns);
    items.value.push({
      header,
      title,
      title2,
      subtitel,
      subtitel1,
      text,
      icon,
      differenz,
      divider: true,
      inset: true,
      aic: row.aic_Bew_pool,
      menu: false,
      memo: warnung,
    });
  }
  if (!siteData?.zulagen) {
    if (!stdAnzeigeBerechnet && props.std) {
      stdAnzeigeBerechnet = props.std;
    }
    if (stdAnzeigeBerechnet && verbuchtAnzeige.value) {
      diffAnzeige = stdAnzeigeBerechnet - verbuchtAnzeige.value;
      if (stdAnzeigeBerechnet === verbuchtAnzeige.value) {
        allesVerbucht.value = true;
      }
      let val = diffAnzeige;
      valueNegativ.value = false;
      if (val < 0) {
        val = val * -1;
        valueNegativ.value = true;
      }
      let hour = Math.floor(val);
      let min = Math.round((val - hour) * 60);
      if (min === 60) {
        hour += 1;
        min = 0;
      }
      diff.value = zeroPad(hour, 2) + ":" + zeroPad(min, 2);
      if (valueNegativ.value) {
        diff.value = "- " + zeroPad(hour, 2) + ":" + zeroPad(min, 2);
      } else {
        diff.value = zeroPad(hour, 2) + ":" + zeroPad(min, 2);
      }
    } else {
      if (verbuchtAnzeige.value) {
        diffAnzeige = verbuchtAnzeige.value;
        const val = diffAnzeige;
        let hour = Math.floor(val);
        let min = Math.round((val - hour) * 60);
        if (min === 60) {
          hour += 1;
          min = 0;
        }
        diff.value = "- " + zeroPad(hour, 2) + ":" + zeroPad(min, 2);
      } else {
        // DiffAnzeige muss UNFormatiert übergeben werden!
        diffAnzeige = props.std ?? 0;
      }
    }
  }
  if (verbuchtAnzeige.value > 0) {
    const valVerb = verbuchtAnzeige.value;
    const hourVerb = Math.floor(valVerb);
    const minVerb = Math.round((valVerb - hourVerb) * 60);
    verbucht.value = zeroPad(hourVerb, 2) + ":" + zeroPad(minVerb, 2);
  }
  if (stdAnzeigeBerechnet > 0) {
    const valStd = stdAnzeigeBerechnet;
    const hourStd = Math.floor(valStd);
    const minStd = Math.round((valStd - hourStd) * 60);
    stdAnzeigeString.value = zeroPad(hourStd, 2) + ":" + zeroPad(minStd, 2);
  }
  if (!showChart.value) {
    const localChartItems: ChartListItems[] = [];
    const destination = props.std ?? 0;
    const value = destination - verbuchtAnzeige.value;
    localChartItems.push({
      value,
      destination,
    });
    chartItems.value = localChartItems;
    showChart.value = true;
  }

  setCompKeyList.value += +1;
  initalized.value = true;
  uiData.showLoading = false;
  uiData.initialized = true;
}
function zeroPad(num: number, places: number) {
  return String(num).padStart(places, "0");
}

function openNew(bewegungsdaten: boolean) {
  if (AUApi.Current.isBusy) {
    showSnackbar({
      text: globalsBezeichnung(
        Globals.Begriff,
        "Web_Berechnung_laueft:",
        "Berechnung läuft...",
      ),
      duration: 800,
      color: "error",
    });
    return;
  }
  let uebergabeStd = lokaleStd;
  if (diffAnzeige && stdAnzeigeBerechnet) {
    uebergabeStd = diffAnzeige;
  }
  if (allesVerbucht.value) {
    uebergabeStd = 0;
  }
  let showFullscreen = false;
  if (Constants.isMobile && isPhone()) {
    showFullscreen = true;
  }
  let query = "";
  let zulage = false;
  if (siteData?.zulagen) {
    query = "Web_manuelleZulagenerfassung";
    zulage = true;
  }
  showDialog({
    title: globalsBezeichnung(
      Globals.Begriff,
      "Web_Nacherfassung",
      "Nacherfassung",
    ),
    site: "SoftTermProjektstundenEdit",
    width: 400,
    persistent: true,
    fullscreen: showFullscreen,
    noClose: false,
    data: {
      zeitbereich: editZeitbereich,
      stdUebergabe: uebergabeStd,
      newData: true,
      query,
      zulage,
      aic: pageParams.aic,
      stammAic: siteData?.aic,
    },
    onClose: () => {
      completeReload();
      return true;
    },
  });
}
function openEdit(aic: any) {
  let query = "";
  let zulage = false;
  if (siteData?.zulagen) {
    query = "Web_manuelleZulagenerfassung";
    zulage = true;
  }
  let stammAic = 0;
  if (siteData && siteData.aic) {
    stammAic = siteData.aic;
  }
  showDialog({
    title: "bearbeiten",
    site: "SoftTermProjektstundenEdit",
    width: 400,
    data: {
      zeitbereich: editZeitbereich,
      aic,
      bewegungsdaten: true,
      showDelete: true,
      query,
      zulage,
      stammAic,
    },
    onClose: () => {
      completeReload();
      return true;
    },
  });
}
async function completeReload() {
  uiData.showLoading = true;
  uiData.initialized = false;
  initalized.value = false;
  showChart.value = false;

  await reloadData(uiData, pageParams);
  await refreshItems();
}

function warningListLoaded(args?: any) {
  warningBtnVisible.value = false;
  if (props.showError) {
    // wenn es mindestens ein item gibt dann zeigen wirs an
    if (args && args.data && args.data.length > 0) {
      warningBtnVisible.value = true;
    }
  }
  setCompKey.value += +1;
}
</script>
<template>
  <v-card
    class="pa-0"
    v-if="initalized && uiData.initialized"
    :height="heightLocal - 40"
  >
    <v-toolbar
      density="compact"
      elevated
      :color="titleColor"
      style="padding: 0px"
    >
      <v-toolbar-title>
        {{ wochenTag }}
        {{ tag }}
        {{ monat }}
        <span
          v-if="holiday"
          style="color: white; font-size: 10px"
          title="Feiertag"
        >
          {{ holiday.bezeichnung }}
        </span>
      </v-toolbar-title>
      <v-btn
        :key="setCompKey"
        color="warning"
        v-if="warningBtnVisible"
        @click="showDialogLocal = true"
        icon="mdi-alert"
        size="small"
        variant="flat"
      >
      </v-btn>
      <v-btn
        variant="flat"
        color="info"
        size="small"
        icon="mdi-plus"
        @click.prevent.stop="openNew(false)"
      >
      </v-btn>
    </v-toolbar>

    <v-spacer></v-spacer>

    <v-virtual-scroll
      :height="heightLocal - 80"
      :items="items"
      v-if="
        siteData?.zulagen && uiData.initialized && items && items.length > 0
      "
    >
      <template v-slot:default="{ item }">
        <v-list-item ref="liste" :key="item.title">
          <v-list-item-subtitle>{{ item.title }}</v-list-item-subtitle>

          <v-list-item-subtitle v-if="item.memo">{{
            item.memo
          }}</v-list-item-subtitle>
          <template v-slot:append>
            {{ item.header }}
            <v-btn
              v-if="item.aic"
              variant="text"
              size="small"
              @click.prevent.stop="openEdit(item.aic)"
            >
              <v-icon color="success">mdi-pencil</v-icon>
            </v-btn>
          </template>
        </v-list-item>
      </template>
    </v-virtual-scroll>

    <v-card-text v-if="!siteData?.zulagen && uiData.initialized">
      <v-list lines="three" subheader>
        <v-list-item>
          <v-list-item-subtitle v-if="von"
            >{{ globalsBezeichnung(Globals.Begriff, "von", "von") }}:
            {{ von }}
            {{ globalsBezeichnung(Globals.Begriff, "bis", "bis") }}:
            {{ bis }}</v-list-item-subtitle
          >

          <v-list-item-subtitle v-if="stdAnzeige && !stdAnzeigeString"
            >{{ stdAnzeige }} h
            {{
              globalsBezeichnung(
                Globals.Begriff,
                "Web_verteilbar",
                "verteilbar",
              )
            }}</v-list-item-subtitle
          >
          <v-list-item-subtitle v-if="stdAnzeigeString"
            >{{ stdAnzeigeString }} h
            {{
              globalsBezeichnung(
                Globals.Begriff,
                "Web_verteilbar",
                "verteilbar",
              )
            }}</v-list-item-subtitle
          >
          <v-list-item-subtitle v-if="verbuchtAnzeige"
            >{{ verbucht }} h
            {{
              globalsBezeichnung(Globals.Begriff, "Web_verbucht", "verbucht")
            }}</v-list-item-subtitle
          >
          <template v-slot:append>
            <div v-if="diff && !valueNegativ" style="color: red">
              {{ diff }} h
            </div>
            <div v-if="diff && valueNegativ" style="color: black">
              {{ diff }} h
            </div>
            <div v-if="!diff" style="color: red">{{ stdAnzeige }} h</div>
          </template>
        </v-list-item>

        <v-divider color="red"></v-divider>

        <v-virtual-scroll
          :height="heightLocal - 180"
          :items="items"
          v-if="items && items.length > 0"
        >
          <template v-slot:default="{ item }">
            <v-list-item
              ref="liste"
              :title="item.title"
              :subtitle="item.title2"
              :key="item.title"
            >
              <!-- <v-list-item-subtitle>{{ item.title }}</v-list-item-subtitle> -->
              <!-- <v-list-item-subtitle>{{ item.title2 }}</v-list-item-subtitle> -->
              <v-list-item-subtitle>{{ item.subtitel }}</v-list-item-subtitle>
              <v-list-item-subtitle>{{ item.text }}</v-list-item-subtitle>
              <v-list-item-subtitle style="color: red" v-if="item.memo">{{
                item.memo
              }}</v-list-item-subtitle>
              <template v-slot:append>
                <v-btn
                  v-if="item.aic"
                  variant="text"
                  size="small"
                  @click.prevent.stop="openEdit(item.aic)"
                >
                  <v-icon color="success">mdi-pencil</v-icon>
                </v-btn>
                {{ item.header }}
              </template>
            </v-list-item>
            <v-divider :inset="true"></v-divider>
          </template>
        </v-virtual-scroll>
      </v-list>
    </v-card-text>
  </v-card>
  <v-dialog
    leave-absolute="true"
    id="warnung"
    max-width="300px"
    eager
    v-model="showDialogLocal"
    scrollable
  >
    <v-sheet>
      <baseList
        :key="setCompKeyList"
        ref="list"
        :showClose="true"
        :showHeader="true"
        :dialog="true"
        v-if="editZeitbereich"
        @back="showDialogLocal = false"
        :zeitbereich="editZeitbereich"
        query="Web_Fehler_TimeLine"
        @dataloaded="warningListLoaded"
        :aic="pageParams.queryAIC"
      />
    </v-sheet>
  </v-dialog>
</template>

<style scoped>
.scroll {
  overflow-y: auto;
}
</style>
